// @flow

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import MainTemplate from 'components/templates/MainTemplate'
import RoomReputationListPage from 'components/pages/RoomReputationListPage'
import { setUIState } from 'redux/modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { roomName } from 'frontend_core/dist/helpers/format'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import { type Room as RoomType } from 'types/room'

import graphql from './graphql'

type PropTypes = {
  data: {
    room: RoomType,
  },
  location: {
    search: string,
    pathname: string,
  },
  match: {
    params: {
      roomId?: number | string,
    },
  },
  config: {
    ORIGIN: string,
  },
}

class RoomReputationListPageContainer extends Component<PropTypes> {
  render() {
    const { data, location, config } = this.props
    const { room } = data

    if (!data || !room) {
      this.props.staticContext.status = 404
      return null
    }

    const formattedRoomName = roomName(room)

    const reputationSummary = room.reputationSummary || {}

    const pageInfo = room.reputations.pageInfo
    const pagerProps = {
      ...pageInfo,
      windowSize: 4.5,
      onChangePage: (page: number) => {
        window.location.href = `${location.pathname}?page=${page}`
      },
      getPageLink: (page: number) => `${location.pathname}?page=${page}`,
    }

    const breadcrumbs = room.breadcrumbs.slice(1)
    breadcrumbs.push({ title: i18n.t('page.review.breadcrumb'), path: '' })

    return (
      <MainTemplate
        title={i18n.t('server.www.review.title', {
          roomName: formattedRoomName,
        })}
        description={i18n.t('server.www.review.description', {
          spaceName: (room.space || {}).name,
          spaceState: (room.space || {}).stateText,
          roomName: formattedRoomName,
          reputationCount: (room.reputationSummary || {}).count,
        })}
        image={imagePath('www/common/ogimage.png')}
        linkCanonical={`${config.ORIGIN}${location.pathname}`}
        linkPrev={
          pageInfo.hasPreviousPage
            ? `${location.pathname}?page=${pageInfo.previousPage || 1}`
            : null
        }
        linkNext={
          pageInfo.hasNextPage
            ? `${location.pathname}?page=${pageInfo.nextPage || 1}`
            : null
        }
        data={this.props.data}
        {...this.props}
      >
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <RoomReputationListPage
          room={room}
          owner={room.owner}
          summary={reputationSummary}
          reputations={room.reputations.results}
          pageInfo={pagerProps}
        />
      </MainTemplate>
    )
  }
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(RoomReputationListPageContainer)),
)



// WEBPACK FOOTER //
// ./src/containers/pages/RoomReputationListPage/index.jsx